import Table, {
  TableBody,
  TableBodyProps,
  TableHeader,
  TableHeaderProps,
  TableProps,
} from "@ingka/table";
import "@ingka/text/dist/style.css";
import "@ingka/table/dist/style.css";

const FixaTable = (props: TableProps) => (
  <Table {...props}>{props.children}</Table>
);

const FixaTableBody = (props: TableBodyProps) => (
  <TableBody {...props}>{props.children}</TableBody>
);

const FixaTableHeader = (props: TableHeaderProps) => (
  <TableHeader {...props}>{props.children}</TableHeader>
);

export { FixaTableHeader, FixaTableBody };

export default FixaTable;
